import { PipeTransform, Pipe } from '@angular/core';
import * as _ from 'lodash';

@Pipe({ name: 'enumstrings' })
export class EnumStringsPipe implements PipeTransform {

    transform(value, args: string[]): any {

        // loop over the enum and extract the values
        const kvPairs = Object.keys(value).map((enumMember, index) => {
            return { key: index, value: value[enumMember] };
        });

        // return the key value pairs
        return kvPairs;

    }
}



// WEBPACK FOOTER //
// ./client/app/shared/pipes/enum-strings.pipe.ts